import FullWidthBarBreadcrumbs from '@/components/Breadcrumb/FullWidthBarBreadcrumbs';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import { H3 } from '@/components/Element/Heading';
import MetaTags from '@/components/Head/MetaTags';
import SimpleCenteredHeaderSection from '@/components/HeaderSection/SimpleCenteredHeaderSection';
import { PHONE_DISPLAY, PHONE_NUMBER } from 'lib/constants';
import Link from 'next/link';
import ContactForm from '@/components/ContactForm';
import FormSectionWrapper from '@/components/FormSection/FormSectionWrapper';

const faqs = [
  {
    question:
      'How can I reach the EnergyPal Service department? Who do I speak with about my solar project?',
    answer: (
      <>
        You may contact your Solar Advisor directly by phone or by replying to
        your email updates. Additionally, if you have other project questions
        you may request contact from a Project Management supervisor by entering
        your information&nbsp;
        <Link href="/contact-us-customer-care#contactForm">here</Link>
        &nbsp; or calling <a href={`tel:${PHONE_NUMBER}`}>{PHONE_DISPLAY}</a>.
      </>
    ),
  },
  {
    question: 'How do I refer a friend?',
    answer: (
      <>
        EnergyPal appreciates you spreading the word and sharing our information
        with your friends, family and other potential go-solar homeowners. If
        you&apos;d like to refer someone to get quotes for solar,&nbsp;
        <Link href="/refer">use this referral form</Link>. When they go solar
        you could be eligible to receive a bonus!
      </>
    ),
  },
  {
    question: 'What is the company mailing address?',
    answer: (
      <>
        EnergyPal
        <br />
        8005 Financial Dr, Suite 323
        <br />
        Brampton, On, Canada L6Y6A1
      </>
    ),
  },
];

export default function Page() {
  return (
    <article>
      <MetaTags
        title="Contact Us & Customer Care - EnergyPal"
        description="Get exceptional solar customer support with EnergyPal. Contact us for quotes, assistance, and partnerships. Our advisors are always available to help you."
      />
      <SimpleCenteredHeaderSection
        dark
        title="Customer Care"
        subTitle="Thanks for your interest in EnergyPal! We're dedicated to customer satisfaction and making solar energy accessible to homeowners across North America. For product inquiries, quotes, or customer service, please use the contact information provided below."
      />
      <FullWidthBarBreadcrumbs
        pages={[
          {
            name: 'Customer Care',
            href: '/contact-us-customer-care',
          },
        ]}
      />
      <div id="contactForm">
        <FormSectionWrapper
          title="Home Solar Customer Service"
          subTitle="One of EnergyPal's highly-trained Solar Advisors will be happy to
          assist you. Start by filling out your contact information below:"
        >
          <ContactForm />
        </FormSectionWrapper>
      </div>
      <CenteredContentSection>
        <H3>Common help questions:</H3>
        <dl className="space-y-12">
          {faqs.map((faq) => (
            <div key={faq.question}>
              <dt className="text-lg font-medium leading-6 text-gray-900">
                {faq.question}
              </dt>
              <dd className="mt-2 text-base text-gray-500">{faq.answer}</dd>
            </div>
          ))}
        </dl>
      </CenteredContentSection>
    </article>
  );
}
